import { NavigationContent, Section, SideNavigation } from '@atlaskit/side-navigation';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import { NavColumn } from '@townsquare/responsive-grid';

import { SidebarItems } from './SidebarItems';
import { AddPeople } from './components/AddPeople/AddPeople';
import { StyledHeadingItem } from './styles';
import { SidebarNavigationProps } from './types';

export const SidebarNavigation = (props: SidebarNavigationProps) => {
  const { label, testId, sections, selectedKey } = props;

  return (
    <NavColumn>
      <SideNavigation label={label} testId={testId}>
        <NavigationContent>
          {sections.map((section, i) => (
            <Section key={section.title || `section-${i}`} testId={section.testId}>
              <StyledHeadingItem>
                {section.testId === 'topic-update-menu-items' && section.items.length > 0 ? (
                  <FormattedMessage
                    id="townsquare.sidebar-navigation.update-feeds.heading"
                    defaultMessage="Update feeds"
                    description="Heading for the update feeds section of the sidebar"
                  />
                ) : (
                  section.title
                )}
              </StyledHeadingItem>
              {section.customState || <SidebarItems items={section.items} selectedKey={selectedKey} />}
            </Section>
          ))}
        </NavigationContent>
        <AddPeople />
      </SideNavigation>
    </NavColumn>
  );
};
